module.exports = __webpack_public_path__ + "static/media/Data_insight_en_1-2.e523f985.svg";